import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

function TranslatedBadge({ type, translationKey, placeholder, color }) {
    const containerClassNames = [
        'product-badge',
        'product-badge--' + type,
        'product-badge--' + color,
    ].join(' ');

    return (
        <Translation
            tagName="div"
            translationKey={translationKey}
            placeholder={placeholder}
            className={containerClassNames}
        />
    );
}

TranslatedBadge.propTypes = {
    type: PropTypes.string.isRequired,
    translationKey: PropTypes.string.isRequired,
    placeholder: PropTypes.object,
};

TranslatedBadge.defaultProps = {
    placeholder: {},
};

export { TranslatedBadge };
